/**
 * Formats an ISO timestamp as a human-readable date and time, e.g.
 * `August 27, 2026 10:00 AM`.
 *
 * Kept local to the module (rather than importing the shell app's shared
 * helper) so the module stays within its import boundary and travels intact
 * on extraction — see the module README's portability rules.
 */
export const printDateAndTime = (input: string): string => {
  const date = new Date(input);
  const day = date.toLocaleString([], {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
  const time = date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });

  return `${day} ${time}`;
};
